// Generated by ReScript, PLEASE EDIT WITH CARE


var dummy_goods_selection = [
  {
    id: 1,
    name: "Timber/Furniture"
  },
  {
    id: 2,
    name: "Tiles/Ceramics/Sanitary"
  },
  {
    id: 9,
    name: "Metal/Machine tools"
  },
  {
    id: 4,
    name: "Paint/Plastics"
  },
  {
    id: 5,
    name: "Services"
  },
  {
    id: 7,
    name: "Textiles"
  },
  {
    id: 8,
    name: "Paper/Packaging"
  },
  {
    id: 6,
    name: "Electrical/Electronics"
  },
  {
    id: 13,
    name: "General"
  },
  {
    id: 14,
    name: "(Perishable)Vegetable/Fruits/flowers/Dairy/Meat/Grocery"
  }
];

var navbar_title = "Review Order Summary";

var goods_type_title = "Goods Type";

var goods_type_button = "Change";

var goods_type_default_value = "Select a Goods Type";

var goods_type_modal_title = "Select Goods Type";

var goods_type_modal_button = "Book Now";

var books_now_goods_selection_cta = "Select Goods Type";

var book_now_button = "Book ";

var agreed_docs_text = "By booking, you agree to our new ";

var terms_and_condition_label = "Terms & Conditions ";

var privacy_policy_label = "Privacy Policy";

var and_text = " and ";

var update_agreed_docs_error = "Failed to update agreed docs";

var tnc_attribute = "TERMS_AND_CONDITIONS";

var privacy_policy_attribute = "PRIVACY_POLICY";

var seo_title = "Order Review | Porter";

var seo_description = "Looking to hire a mini truck? Use the Porter App. Get tata ace at doorstep in 30 mins. Faster, economical, hassle-free mini truck booking. Choose from over 3000 trained drivers & a wide range of dedicated vehicles.";

var fare_breakup_modal_title = "Fare breakup";

var net_fare = "Net Fare";

var previous_dues = "Previous Dues";

var porter_gold_fee = "Porter Gold Fees";

var porter_credits_applied = "Porter Credits Applied";

var amount_payable = "Amount Payable";

var ga_page_landing = "fe_review_land";

var moe_page_landing_parameter = "fe_review_land_moe";

var ga_select_goods = "fe_selectgoods_cta_confirm_tap";

var moe_select_goods_parameter = "fe_selectgoods_cta_confirm_tap_moe";

var ga_select_goods_parameter = "fe_selectgoods_cta_confirm_tap_parameter";

var ga_relogin = "fe_review_relogin_tap";

export {
  navbar_title ,
  goods_type_title ,
  goods_type_button ,
  goods_type_default_value ,
  goods_type_modal_title ,
  goods_type_modal_button ,
  books_now_goods_selection_cta ,
  book_now_button ,
  agreed_docs_text ,
  terms_and_condition_label ,
  privacy_policy_label ,
  and_text ,
  update_agreed_docs_error ,
  tnc_attribute ,
  privacy_policy_attribute ,
  seo_title ,
  seo_description ,
  fare_breakup_modal_title ,
  net_fare ,
  previous_dues ,
  porter_gold_fee ,
  porter_credits_applied ,
  amount_payable ,
  ga_page_landing ,
  moe_page_landing_parameter ,
  ga_select_goods ,
  moe_select_goods_parameter ,
  ga_select_goods_parameter ,
  ga_relogin ,
  dummy_goods_selection ,
}
/* No side effect */
